import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'br', 'fr', 'zh', 'ru', 'hi', 'ar'],
    defaultNS: 'providerRoom',
    ns: ['providerRoom', 'auth', 'link', 'settings', 'errors', 'teleconsent'],
    load: 'languageOnly',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'app-language',
    },
    react: {
      useSuspense: true,
    },
  });

if (typeof document !== 'undefined') {
  const applyHtmlAttributes = (language: string) => {
    if (language === 'es') {
      document.documentElement.lang = 'es';
    } else if (language === 'br') {
      document.documentElement.lang = 'pt-BR';
    } else if (language === 'fr') {
      document.documentElement.lang = 'fr';
    } else if (language === 'zh') {
      document.documentElement.lang = 'zh-CN';
    } else if (language === 'ru') {
      document.documentElement.lang = 'ru';
    } else if (language === 'hi') {
      document.documentElement.lang = 'hi';
    } else if (language === 'ar') {
      document.documentElement.lang = 'ar';
    } else {
      document.documentElement.lang = 'en';
    }

    const direction = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = direction;
    document.body?.setAttribute('dir', direction);
  };

  applyHtmlAttributes(i18n.resolvedLanguage || i18n.language || 'en');
  i18n.on('languageChanged', applyHtmlAttributes);
}

export default i18n;
